import moment from '../lib/moment'

import {
  REQUEST_TIDES,
  RECEIVE_TIDES
} from '../actions'

import {
  tideStationSelector,
} from './uiReducer'



// ============
// = Reducers =
// ============

const initStationTideState = {
  ranges: [],
  tides: [],
  tideHeightRange: {min: null, max: null},
}

function stationTideReducer(state=initStationTideState, action) {
  switch (action.type) {

  case REQUEST_TIDES:
    return {
      ...state,
      ranges: [
        ...state.ranges.slice(),
        {
          range: action.range,
          isFetching: true
        }
      ]
    }

  case RECEIVE_TIDES:

    // Find index of matching date range
    const index = state.ranges.findIndex(
      rangeEntry => rangeEntry.range.isSame(action.range)
    )

    // Update date ranges
    const ranges = state.ranges.slice()
    ranges.splice(index, 1, {
      range: action.range,
      // tides: action.tides,
      isFetching: false
    })

    // Update tides
    const tideIds = action.tides.map(tide => tide.id)
    const tides = state.tides.concat(tideIds)
    tides.sort()

    // get min & max tide heights, compared to existing values
    const tideHeights = action.tides.map(t => t.v)
    const min = Math.min(state.tideHeightRange.min, ...tideHeights)
    const max = Math.max(state.tideHeightRange.max, ...tideHeights)
    const tideHeightRange = { min, max }

    return { ranges, tides, tideHeightRange }

  default:
    return state
  }
}

export default function(state={}, action) {
  switch (action.type) {
  case REQUEST_TIDES:
  case RECEIVE_TIDES:
    return {
      ...state,
      [action.stationId]: stationTideReducer(state[action.stationId], action)
    }
  default:
    return state
  }
}








// =============
// = Selectors =
// =============

// Select tide by id
function tideByIdSelector(state, tideId) {
  return state.entities.tides[tideId]
}

// Select tides for a given tide station and date range
function tidesSelector(state, stationId, range) {
  const stationTides = state.tidesByStationId[stationId]
  if (stationTides == null)
    return []
  else {
    const tideIds = stationTides.tides
    const tides = tideIds.map(
      tideId => tideByIdSelector(state, tideId)
    )
    return tides.filter(
      tide => tide.moment.within(range)
    )
  }
}

// Select a day oftides based on selectedTideStation and selectedDate
export function dateTidesSelector(state, rangeType, requestedDate) {
  const {
    selectedTideStation,
    selectedDate
  } = state.ui

  const date = (requestedDate == null) ? selectedDate : requestedDate

  if (date == null || selectedTideStation == null)
    return []

  let range = null
  switch (rangeType) {
    case 'DAY':
      range = moment.range(
        date.clone().startOf('day'),
        date.clone().endOf('day')
      )
      break;
    case 'THREE_DAY':
      range = moment.range(
        date.clone().subtract(1,'day').startOf('day'),
        date.clone().add(1,'day').endOf('day')
      )
      break;
    case 'MONTH':
      range = moment.range(
        date.clone().startOf('MONTH'),
        date.clone().endOf('MONTH')
      )
      break;
    default:
  }

  return tidesSelector(state, selectedTideStation.stationId, range)
}

// Select min & max tide heights
export function tideHeightRangeSelector(state, stationId) {
  if (stationId == null)
    stationId = tideStationSelector(state).stationId
  const stationTides = state.tidesByStationId[stationId]
  if (stationTides == null)
    return {}
  else
    return stationTides.tideHeightRange
}



window.tidesSelector = tidesSelector
window.dateTidesSelector = dateTidesSelector
window.tideHeightRangeSelector = tideHeightRangeSelector



// WEBPACK FOOTER //
// ./src/reducers/tidesReducer.js